import {
    SET_USER, 
    SET_ERRORS,
    CLEAR_ERRORS,LOADING_UI,
    SET_UNAUTHENTICATED,
    LOADER_CHECK,
    LOADER_FALSE,
    TICKET_LIST
    } from '../type';
 

    const initialState = {
        TicketAllList: [],
        loader: false,
      };

      
      export default function (state = initialState, action) {
        switch (action.type) {
          case SET_UNAUTHENTICATED:
            return initialState;
          case TICKET_LIST:
            return {
              ...state,
              TicketAllList: action.payload,
              loading: false,
            };
            case LOADER_CHECK:
              return {
                ...state,
                loader: true,
              };
            case LOADER_FALSE:
              return {
                ...state,
                loader: false,
              };
          default:
            return state;
        }
      }